module.exports = __webpack_public_path__ + "img/NLD.69a4a908.svg";